import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const maintenanceSalaryCombinationCodeService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/MaintenanceSalaryCombinationCode`, { headers });
  },
  getAllActive: async () => {
    return await axios.get(`${domain}/api/MaintenanceSalaryCombinationCode/active`, { headers });
  },
  getById: async (id) => {
    return await axios.get(`${domain}/api/MaintenanceSalaryCombinationCode/${id}`, { headers });
  },
  create: async (payload) => {
    return await axios.post(`${domain}/api/MaintenanceSalaryCombinationCode`, payload, { headers });
  },
  update: async (id, payload) => {
    return await axios.put(`${domain}/api/MaintenanceSalaryCombinationCode/${id}`, payload, { headers });
  },
};

export default maintenanceSalaryCombinationCodeService;